// Widget CSS
import '@/css/_elementor/widgets/card_grid.css';

// ..........................................................................................

import { ShuffleColors } from '@/js/utilities/color-shuffle';

// ..........................................................................................

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/card_grid.default', (scope) => {
		const scopeEl = scope[0];

		// ......................................................

		const containerEl = scopeEl.querySelector('.card_grid');

		if (!containerEl) return;

		new ShuffleColors({
			container: containerEl,
			items: '.card',
			colors: ['#F9D757', '#C9D0FC', '#94C3FC', '#B0EAC3', '#EB6942'],
		});

		//
	});
});
